/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
  .controller('ContentBlockController', ['$scope', '$window', 'Restangular', 'BulbBrowserService', 'BulbPageService', ContentBlockController]);

/**
 *
 */
function ContentBlockController($scope, $window, Restangular, BulbBrowserService, BulbPageService) {
  const that = this;

  this.contentElement = null;

  this.frameElement = null;

  this.selected = false;

  this.busy = false;

  this.isFullWidth = false;

  // This is mainly used to determine which library to use for audio uploads
  this.isMobile = BulbBrowserService.isMobile();

  this.downloadAttachedFile = function () {
    $window.location = that.contentBlock.attachedFileAsset.url;
  };

  this.refetchContentBlock = function () {
    Restangular.one('units', this.page.unit.id)
      .one('contentblock', this.contentBlock.id)
      .get().then(
        (contentBlock) => {
          angular.copy(contentBlock.plain(), that.contentBlock);
        },
      );
  };

  /**
   * Add margin to list elements.
   */
  $scope.$watch(() => that.contentElement, () => {
    BulbPageService.addMarginToListForMediumEditor();
  });

  $scope.$on('selectionChange', (event, selection) => {
    that.selected = selection[0] === that.contentBlockElement[0];
  });
}
